import { ID } from "shared/interfaces/common";

export const DIALOG_PRIMARY_BUTTON_ACTION = "dialogPrimaryButtonAction";
export const DIALOG_ADDITIONAL_BUTTON_ACTION = "dialogAdditionalButtonAction";
export const SIGN_IN_ACTION = "signInAction";
export const LOGIN_ACTION = "loginAction";
export const RESEND_CODE_ACTION = "resendCodeAction";
export const REQUEST_PROFILE_DATA_ACTION = "requestProfileDataAction";
export const SEND_ABOUT_PROFILE_DATA_ACTION = "sendAboutProfileDataAction";
export const SEND_PROFILE_ADDRESS_DATA_ACTION = "sendProfileAddressDataAction";
export const FETCH_COMPANY_DATA_ACTION = "fetchCompanyDataAction";
export const FETCH_HONESTY_QUESTIONS_ACTION = "fetchHonestyQuestionsAction";
export const SEND_COMPANY_DETAILS_ACTION = "sendCompanyDetailsAction";
export const SEND_COMPANY_ADDRESS_ACTION = "sendCompanyAddressAction";
export const SEND_COMPANY_CONTACTS_ACTION = "sendCompanyContactsAction";
export const SEND_COMPANY_HONESTY_QUESTIONS_ACTION = "sendCompanyHonestyQuestionsAction";
export const SEND_COMPANY_PRIMARY_CONTACT_ACTION = "sendCompanyPrimaryContactAction";
export const FETCH_ROLE_AND_PERMISSIONS = "fetchRoleAndPermissions";
export const FETCH_ROLE_DETAILS = "fetchRoleDetails";
export const FETCH_COMPANY_ROLES = "fetchCompanyRoles";
export const FETCH_TENANT_MEMBERSHIP = "fetchTenantMembership";
export const FETCH_USER_DETAILS_FOR_INTERNAL_USER = "fetchUserDetailsForInternalUser";
export const REFETCH_USER_DETAILS_FOR_INTERNAL_USER = "refetchUserDetailsForInternalUser";
export const FETCH_COMPANY_USER_PROFILE = "fetchCompanyUserProfile";
export const LOAD_RR_DATA_ACTION = "loadReleaseRequestDataAction";
export const LOAD_SETTLEMENTS_ACTION = "loadSettlementsAction";
export const LOAD_TENANCY_ACTION = "loadTenancyAction";
export const FETCH_BUSINESSES_AGENCY = "fetchBusinessesAgency";
export const ADD_PROPERTY_ACTION = "addPropertyAction";
export const REQUEST_DEACTIVATION_REASONS = "requestDeactivationReasons";
export const BULK_UPLOAD_INITIAL_DATA = "bulkUploadInitialData";
export const CANCEL_IMPORT_PROPERTIES = "cancelImportProperties";
export const REMOTE_TABLE_FETCH_DATA = "remoteTableFetchData";
export const UPDATE_VOUCHERS_SETTINGS = "updateVoucherSettings";
export const LOAD_CLAIM_DATA_ACTION = "loadClaimDataAction";
export const LOAD_PROPERTY_DATA_ACTION = "loadPropertyDataAction";
export const UPDATE_PROPERTY_DATA_ACTION = "updatePropertyData";
export const FETCH_AGENCIES = "fetchAgencies";
export const MOVE_TO_AGENCY_REQUEST = "moveToAgencyRequest";
export const START_MEMBERSHIP_WITH_VOUCHER = "startMembershipWithVoucher";
export const INVITE_LANDLORD_INTO_PROPERTY = "inviteLandlordIntoProperty";
export const FETCH_RECENT_ACTIVITIES_WIDGET = "fetchRecentActivitiesWidget";
export const FETCH_PROPERTIES_WIDGET = "fetchPropertiesWidget";
export const FETCH_PROPERTIES_BY_STATUS_WIDGET = "fetchPropertiesByStatusWidget";
export const UPDATE_TENANCY_DETAILS = "updateTenancyDetails";
export const FETCH_TENANCY = "fetchTenancy";
export const UPDATE_TENANCY_LEAD_TENANT = "updateTenancyLeadTenant";
export const FETCH_TENANTS_AND_LEAD_TENANT = "fetchTenantsAndLeadTenant";
export const FETCH_TENANCY_AND_TENANTS = "fetchTenancyAndTenants";
export const COUNTING_TRADITIONAL_DEPOSIT = "countingTraditionalDeposit";
export const CONFIRM_END_OF_TENANCY = "confirmEndOfTenancy";
export const FETCH_ALTERNATIVE_LEAD_TENANTS = "fetchAlternativeLeadTenants";
export const FETCH_END_OF_TENANCY_CONFIRMATION = "fetchEndOfTenancyConfirmation";
export const TENANTS_RESEND_INVITATION = (index: ID): string => `tenantsResendInvitation[${index}]`;
export const DOWNLOADING_MEMBERSHIP_CERTIFICATE = "downloadingMembershipCertificate";
export const FINISH_MEMBERSHIP_INTERNAL = "finishMembershipInternal";
export const FETCH_BRANCHES_LOOKUP_BULK_UPLOAD = "fetchBranchesLookupBulkUpload";
export const CONFIRM_END_OF_TENANCY_MEMBERSHIP = "confirmEndOfTenancyMembership";
export const RESET_END_OF_TENANCY_PAYMENT_VARIANT = "resetEndOfTenancyPaymentVariant";
export const SAVE_DOCUMENTS = "saveDocuments";
export const CANCEL_END_OF_TENANCY_PROCESS = "cancelEndOfTenancyProcess";
export const CONFIRM_MEMBERSHIP_BY_INTERNAL = "confirmMembershipByInternal";
export const APPLY_MEMBERSHIP_VOUCHER = "applyMembershipVoucher";
export const UPDATE_END_OF_TENANCY_PAYMENT_VARIANT = "updateEndOfTenancyPaymentVariant";
export const ADMIN_CHANGE_MEMBERSHIP_PAYMENT_OPTION = "adminChangeMembershipPaymentOption";
export const LOADING_AUDIT_LOG_ENTRY_DETAILS = "loadingAuditLogEntryDetails";
export const FETCH_EMPLOYMENT_STATUSES = "fetchEmploymentStatuses";
export const ADMIN_CREATE_USER = "adminCreateUser";
export const ADMIN_FETCH_ROLES_FOR_CREATE_USER = "adminFetchRolesForCreateUser";
export const VERIFY_PHONE_NUMBER = "verifyPhoneNumber";
export const UPDATE_MISSING_DETAILS = "updateMissingDetails";
export const VERIFY_COMPANY_REGISTRATION_NUMBER = "verifyCompanyRegistrationNumber";
export const DELETE_NOTIFICATION = (index: ID): string => `deleteNotification${index}`;
export const DELETE_ALL_NOTIFICATIONS = "deleteAllNotifications";

export const isPrimaryButtonAction = (actionName: string): boolean => {
    return actionName === DIALOG_PRIMARY_BUTTON_ACTION;
};

export const isAdditionalButtonAction = (actionName: string): boolean => {
    return actionName === DIALOG_ADDITIONAL_BUTTON_ACTION;
};
